module.exports = __webpack_public_path__ + "img/day_ezn.61cbfd4d.gif";